import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import "bootstrap/dist/css/bootstrap.css";
import "../src/assets/ding.css"; // 导入自定义 css
import "../src/assets/sidebars/sidebars.css"; // 个人中心的左侧菜单栏样式
import "qweather-icons/font/qweather-icons.css"  // 和风天气图标

// 路由门卫,在声明路由时须配置 requireAuth: true 才会到此处
router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth) {
        if (localStorage.getItem("authorization") == "undefined" || localStorage.getItem("authorization") == null) {
            next({
                path: '/',
                replace: true
            });
        }
        else {
            next()
        }
    }
    else {
        next();
    } 
});

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fas,far,fab)
createApp(App).use(router).component('font-awesome-icon', FontAwesomeIcon).mount("#app");
